import { createSlice } from "@reduxjs/toolkit";
// utils
import { PATH_DASHBOARD } from "../../routes/paths";
import axios from "../../utils/axios";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  update: false,
  games: [],
  fetchLoading: false,
  singleGame: null,
};

const slice = createSlice({
  name: "game",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    stopLoading(state) {
      state.isLoading = false;
      state.fetchLoading = false;
    },

    // START LOADING
    fetchLoading(state) {
      state.fetchLoading = true;
    },
    // UPDATE EVENT
    updateGameSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.games = state.games.map((game) => {
        if (game.id === action.payload.id) {
          return action.payload;
        }
        return game;
      });
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.update = false;
      state.error = action.payload;
    },

    // GET PRODUCTS
    getGameSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.games = action.payload;
    },

    // GET SINGLE SUCCESS
    getSingleGameSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.singleGame = action.payload;
    },

    // GET PRODUCTS
    createGameSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.games = [...state.games, action.payload];
    },

    // DELETE EVENT
    deleteGameSuccess(state, action) {
      const gameId = action.payload;
      state.games = state.games.filter((game) => game.id !== gameId);
      state.isLoading = false;
      state.fetchLoading = false;
    },

    updateGameTimeSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.singleGame = { ...state.singleGame, details: action.payload };
    },

    updateGameDetailSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.singleGame = { ...state.singleGame, details: action.payload };
    },

    updatePauseTimeSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.singleGame = { ...state.singleGame, ...action.payload };
    },
  },
});

export default slice.reducer;

export function getGames({ season_id }) {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get("games", {
        params: {
          season_id,
        },
      });
      dispatch(slice.actions.getGameSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getSingleGame({ id }) {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get(`games/${id}`);
      dispatch(slice.actions.getSingleGameSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function createGame({ data, enqueueSnackbar, navigate }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post("games", data);
      dispatch(slice.actions.createGameSuccess(response.data.data));
      enqueueSnackbar("Game is added successfully");
      navigate(PATH_DASHBOARD.games.list);
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateGame({ id, data, enqueueSnackbar, setOpenEdit }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.patch(`games/${id}`, data);
      dispatch(slice.actions.updateGameSuccess(response.data.data));
      enqueueSnackbar("Game is updated successfully");
      setOpenEdit(false);
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO:update pause timers
export function updateGamePauseTime({
  id,
  data,
  enqueueSnackbar,
  setOpenEdit,
}) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.patch(`games/${id}`, data);
      dispatch(slice.actions.updatePauseTimeSuccess(response.data.data));
      setOpenEdit && setOpenEdit(false);
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateReferenceTime({
  id,
  data,
  enqueueSnackbar,
  setOpenEdit,
}) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.patch(`games/${id}`, data);
      dispatch(slice.actions.updatePauseTimeSuccess(response.data.data));
      setOpenEdit && setOpenEdit(false);
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteGame({ id, enqueueSnackbar, setOpenConfirm }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`games/${id}`);
      dispatch(slice.actions.deleteGameSuccess(id));
      enqueueSnackbar("Game is deleted successfully");
      setOpenConfirm(false);
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

// TODO: timer functions
export function updateGameTimers({
  id,
  data,
  enqueueSnackbar,
  winner_id,
  first_team_score,
  second_team_score,
  gameId,
  sync_ref_time_FH,
  sync_ref_time_SH,
  sync_pause_time,
  total_paused_first,
  pause_time,
  update_points = false,
}) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.patch(`game-details/time/${id}`, {
        ...data,
        ...(winner_id && {
          winner_id,
          first_team_score,
          second_team_score,
          status: first_team_score !== second_team_score ? 1 : 0, // O for draw and 1 for not draw
        }),
      });
      dispatch(slice.actions.updateGameTimeSuccess(response.data.data));

      if (sync_ref_time_FH) {
        dispatch(
          updateReferenceTime({
            data: {
              total_paused_first: response.data.data.first_half_start_time,
              paused: 0,
            },
            id: gameId,
            enqueueSnackbar,
          })
        );
      }

      if (sync_ref_time_SH) {
        dispatch(
          updateReferenceTime({
            data: {
              total_paused_first,
              paused: 0,
            },
            id: gameId,
            enqueueSnackbar,
          })
        );
      }

      if (sync_pause_time) {
        dispatch(
          updateReferenceTime({
            data: {
              pause_time: response.data.data.first_half_end_time,
              paused: 1,
            },
            id: gameId,
            enqueueSnackbar,
          })
        );
      }

      if (pause_time) {
        dispatch(
          updateReferenceTime({
            data: {
              paused: 1,
            },
            id: gameId,
            enqueueSnackbar,
          })
        );
      }

      if (winner_id) {
        dispatch(
          updateGameDetail({
            data: {
              winner_id,
              first_team_score,
              second_team_score,
              status: first_team_score !== second_team_score ? 1 : 0, // O for draw and 1 for not draw
            },
            enqueueSnackbar,
            id,
          })
        );
      }

      if (update_points) {
        dispatch(
          updateGameDetail({
            data: {
              first_team_score,
              second_team_score,
            },
            enqueueSnackbar,
            id,
          })
        );
      }

      // setOpenEdit(false);
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------
// TODO: update game details
export function updateGameDetail({ id, data, enqueueSnackbar }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.patch(`game-details/${id}`, data);
      dispatch(slice.actions.updateGameDetailSuccess(response.data.data));
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO: update game points after each acitivity post for frontend
export function updateGameDetailPoints({ id, data }) {
  return async (dispatch) => {
    try {
      await axios.patch(`game-details/${id}`, data);
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
